import { useNavigate, useParams } from "react-router-dom";
import CountrySelector from "./CountrySelector";
import { useEffect } from "react";
import localStorageService from "../service/http.localStorage";
import { useI18n } from "../i18n/LanguageContext";
import LanguageSwitch from "./LanguageSwitch";

export default function CountryTake() {
  const navigate = useNavigate();

  const params = useParams();
  useEffect(() => {
    if (!params.country) {
      localStorageService.removeCountry();
    } else {
      localStorageService.setCountry(params.country); // ← чтобы синхронизировать URL и localStorage
    }
  }, [params]);
  const { t } = useI18n();
  const handleSelect = (code) => {
    localStorageService.setCountry(code);
    navigate(`/${code}`);
    // например, положить в Redux или делать fetch по выбранной стране
  };

  const options = [
    { code: "kz", label: t("country.kz"), emoji: "🇰🇿" },
    { code: "ru", label: t("country.ru"), emoji: "🇷🇺" },
    // { code: "us", label: "United States", emoji: "🇺🇸" },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-6 sm:p-8 transform transition-all duration-300 hover:shadow-xl">
        <div className="mb-4 flex justify-center">
          <LanguageSwitch tone="light" />
        </div>
        <div className="text-center mb-6">
          <p className="text-gray-600 text-sm sm:text-base">
            {t("country.prompt")}
          </p>
        </div>
        <CountrySelector
          options={options}
          defaultCode="kz"
          onSelect={handleSelect}
        />
      </div>
    </div>
  );
}
